import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    kpiId = '',
    state = 0,
    summary = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.kpiAudit.auditKpi, {
        kpiId,
        state,
        summary,
    }, options);
    if (error) return { error, status };
    return content || {};
};
